<section class="pt-8 @container">
  <div class="flex flex-wrap items-center gap-2.5 pb-3">
    <h2 class="text-base font-bold tracking-[-0.01em] text-foreground">Letzte Aktivität</h2>
    <span class="font-mono text-2xs text-muted-foreground">Analysen &amp; Massenausführungen</span>
    @if (totalItems() > 0) {
      <span class="ml-auto font-mono text-2xs text-muted-foreground">
        {{ items().length | number }} / {{ totalItems() | number }}
      </span>
    }
  </div>

  <div class="border-t border-border">
    @if (isLoading()) {
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <div class="h-[52px] border-b border-border/60 flex items-center">
          <div class="h-3 w-2/5 rounded bg-muted animate-pulse"></div>
        </div>
      }
    } @else if (loadError()) {
      <p class="py-4 text-sm text-muted-foreground">Aktivität konnte nicht geladen werden.</p>
    } @else {
      <!-- Caps at ~7 rows and scrolls; the next page loads as it nears the end. -->
      <div class="max-h-[364px] overflow-y-auto" (scroll)="onScroll($event)">
        @for (item of items(); track item.kind + item.id + item.updatedAt) {
          <div
            [title]="absoluteTime(item.updatedAt)"
            class="activity-row group relative w-full grid items-center gap-x-4 gap-y-1.5 py-3 border-b border-border/60 pr-1 text-left transition-colors hover:bg-muted/50"
          >
            <!-- Grows out of the middle on hover instead of snapping in. -->
            <span
              class="absolute left-0 inset-y-1.5 w-[2px] rounded-full bg-primary origin-center scale-y-0 opacity-0 transition-all duration-300 ease-out group-hover:scale-y-100 group-hover:opacity-100"
            ></span>

            <span class="pl-3 font-mono text-2xs text-muted-foreground">{{ kindLabel(item) }}</span>

            @if (item.kind === 'analysis') {
              <app-analysis-reference [analysisId]="item.id" [address]="item.address" [organizationSlug]="currentOrgStore.organizationSlug()!" />
            } @else {
              <button type="button" class="truncate text-left text-sm font-normal hover:text-primary" (click)="open(item)">{{ item.title }}</button>
            }

            <div class="min-w-0 flex items-center gap-2.5">
              <span
                class="truncate text-dense"
                [class]="isFailed(item) ? 'text-destructive' : 'text-muted-foreground'"
              >
                {{ action(item) }}
              </span>
              @if (item.counts; as counts) {
                <span class="flex-none w-16 h-[5px] flex gap-px overflow-hidden rounded-full bg-muted">
                  @for (segment of runSegments(counts); track segment.label) {
                    <span class="h-full" [class]="segment.colorClass" [style.width.%]="segment.percent"></span>
                  }
                </span>
                <span class="flex-none font-mono text-2xs text-muted-foreground">
                  {{ counts.succeeded }}/{{ counts.total }}
                </span>
              }
            </div>

            <span class="activity-time font-mono text-2xs text-muted-foreground whitespace-nowrap">
              {{ relativeTime(item.updatedAt) }}
            </span>
          </div>
        } @empty {
          <p class="py-4 text-sm text-muted-foreground">Noch keine Aktivität.</p>
        }

        @if (isLoadingMore()) {
          <div class="h-[52px] flex items-center font-mono text-2xs text-muted-foreground">Lädt…</div>
        }
      </div>
    }
  </div>
</section>
